import React, { Dispatch, useEffect, useState } from 'react';
import { Table, Link, Icon } from '@b-design/fusion';
import Confirm from '@/components/Confirm';
import {
  statusFilters,
  renderTargetApp,
  renderTitle,
  renderId,
  renderStatus,
  renderCreator,
  renderCategory
} from './const';
import './index.less';
import $i18n from '@/i18n';
import Requests from '@/services/request';

interface TableProps {
  dataSource: any[];
  contentHeight: number;
  setFilterValue: Dispatch<any>;
  spaceId: string | (string | null)[] | null;
  onlineOrOffline: any;
  loading: boolean;
}

const ChannelTable: React.FC<TableProps> = (props) => {
  const {
    dataSource = [],
    contentHeight,
    onlineOrOffline,
    setFilterValue,
    spaceId,
    loading,
  } = props;
  // 空间成员
  const [creatorFilters, setCreatorFilters] = useState([]);

  useEffect(() => {
    if (!spaceId) {
      return;
    };
    Requests.get('/rest/intercnn/space/auth/query', {
      authId: spaceId,
      currentPage: 1,
      pageSize: 1000,
    }).then((data) => {
      if (data) {
        const { list = [] } = data;
        const newList = list.map((item: any) => {
          return {
            ...item,
            roleList: item?.role?.split(',') || [],
          }
        })
        setCreatorFilters(newList?.map((i) => ({ label: i?.userNick, value: i?.userNick })));
      }
    });
  }, []);

  const actions = (_v, _i, record) => {
    return (
      <div className="actions-content">
        {record?.publishStatus !== 'BLOCKED' ? (
          <Confirm
            trigger={
              <Link
                style={{
                  padding: '0 5px',
                  fontSize: '12px',
                  color: 'var(--superapp-primary-1)',
                  letterSpacing: '0.4px',
                  lineHeight: '20px',
                }}
              >
                <Icon type="subtract--circle--outline" />
                {$i18n.get({
                  id: 'aopf.pages.channel.channelList.columns.action.forbidden',
                  dm: '禁止',
                })}
              </Link>
            }
            dialogTitle={$i18n.get({
              id: 'aopf.pages.channel.channelList.columns.action.forbidden.dialogTitle',
              dm: '禁止app',
            })}
            dialogContent={$i18n.get({
              id: 'aopf.pages.channel.channelList.columns.action.forbidden.dialog',
              dm: '确定禁止此app?',
            })}
            width={400}
            onClick={onlineOrOffline.bind(null, { appId: record?.appId, channelCode: record?.channelCode, spaceId }, 'forbidden')}
          />
        ) : (
          <Confirm
            trigger={
              <Link
                style={{
                  padding: '0 5px',
                  fontSize: '12px',
                  color: 'var(--superapp-primary-1)',
                  letterSpacing: '0.4px',
                  lineHeight: '20px',
                }}
              >
                <Icon type="animation--3d--mode--outline" />
                {$i18n.get({
                  id: 'aopf.pages.channel.channelList.columns.action.Recover',
                  dm: '恢复',
                })}
              </Link>
            }
            dialogTitle={$i18n.get({
              id: 'aopf.pages.channel.channelList.columns.action.Recover.dialogTitle',
              dm: '恢复App',
            })}
            dialogContent={$i18n.get({
              id: 'aopf.pages.channel.channelList.columns.action.Recover.dialog',
              dm: '确定恢复此app?',
            })}
            width={400}
            onClick={onlineOrOffline.bind(null, { appId: record?.appId, channelCode: record?.channelCode, spaceId }, 'recover')}
          />
        )}
      </div>
    );
  };

  return (
    <div className="miniapp-list-table">
      <Table
        fixedHeader
        maxBodyHeight={contentHeight - 45 - 56}
        dataSource={dataSource}
        loading={loading}
        onFilter={(filterParams) => {
          const filter = {};
          for (const [key, value] of Object.entries(filterParams)) {
            if (key === 'publishStatus') {
              filter['status'] = (value as any)?.selectedKeys?.[0];
            } else {
              filter['createName'] = (value as any)?.selectedKeys?.[0];
            }
          }
          setFilterValue((pre) => ({ ...pre, ...filter }));
        }}
      // emptyContent={
      //   <>
      //     {$i18n.get({
      //       id: 'aopf.pages.miniapp.table.No.Miniapp.now.Click.to.create.one',
      //       dm: '现在没有应用，点击创建一个',
      //     })}
      //     <Link
      //       style={{
      //         padding: '0 5px',
      //         fontSize: '12px',
      //         color: 'var(--superapp-primary-1)',
      //         letterSpacing: '0.4px',
      //         lineHeight: '20px',
      //         marginLeft: 16,
      //       }}
      //     // onClick={() => changeRouter(record)}
      //     >
      //       {$i18n.get({ id: 'aopf.pages.miniapp.table.empty.Create.Miniapp', dm: '创建应用' })}
      //     </Link>
      //   </>
      // }
      >
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Miniapp', dm: '应用名称' })}
          dataIndex="description"
          cell={renderTitle}
          width={180}
        />
        {/* <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.ID', dm: 'ID' })}
          dataIndex="appId"
          // width={180}
          cell={renderId}
        /> */}
        <Table.Column
          title={$i18n.get({
            id: 'aopf.pages.channel.channelList.columns.onlineVersion',
            dm: '线上版本',
          })}
          dataIndex="onlineVersion"
          cell={(value) => (value ? `v${value}` : '')}
        // width={200}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.channel.channelList.columns.status', dm: '状态' })}
          dataIndex="publishStatus"
          cell={renderStatus}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniAppStore.select.category', dm: '类目' })}
          dataIndex="categoryList"
          // width={180}
          cell={renderCategory}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Creator', dm: '创建者' })}
          dataIndex="description"
          cell={renderCreator}

        />
        <Table.Column
          title={$i18n.get({
            id: 'aopf.pages.channel.channelList.columns.targetApp',
            dm: '目标小程序',
          })}
          dataIndex="channelName"
          // width={210}
          cell={renderTargetApp}
        />
        <Table.Column
          title={$i18n.get({ id: 'aopf.pages.miniapp.table.Action', dm: '操作' })}
          cell={actions}
        // width={160}
        />
      </Table>
    </div>
  );
};

export default ChannelTable;
